import styles from "./ItemCounter.module.css";

export default function ItemCounter({ count, count_1, itemCount }) {
  return (
    <main className={styles[`item-counter`]}>
      {itemCount >= 50 ? "50+" : itemCount} {itemCount === 1 ? count_1 : count}
    </main>
  );
}
